// export const getFilteredDocs = (allDocs, type) => {
//   if (!Array.isArray(allDocs)) return [];

//   if (type === "document") {
//     const allowedExtensions = [
//       ".pdf", ".doc", ".docx", ".txt", ".csv", ".xlsx", ".xls",
//       ".mp3", ".wav", ".flac", ".mp4", ".avi", ".mov", ".mkv"
//     ];
//     return allDocs.filter((doc) =>
//       allowedExtensions.some((ext) =>
//         doc.original_filename?.toLowerCase().endsWith(ext) // ✅ Corrected
//       )
//     );
//   }

//   if (type === "url") {
//     return allDocs.filter((doc) => doc.file_type === "url"); // ✅ file_type
//   }

//   if (type === "youtube") {
//     return allDocs.filter((doc) => doc.file_type === "youtube"); // ✅ file_type
//   }

//   return [];
// };

export const getFilteredDocs = (allDocs, type) => {
  if (!Array.isArray(allDocs)) return [];

  if (type === "document") {
    const allowedExtensions = [
      // 📄 Document formats
      ".pdf",
      ".doc",
      ".docx",
      ".txt",
      ".csv",
      ".xlsx",
      ".xls",
      ".ppt",
      ".pptx",

      // 📷 Image formats
      ".png",
      ".jpg",
      ".jpeg",
      ".gif",
      ".bmp",
      ".svg",
      ".webp",
      ".tiff",

      // 🎧 Audio formats
      ".mp3",
      ".wav",
      ".flac",
      ".aac",

      // 🎥 Video formats
      ".mp4",
      ".avi",
      ".mov",
      ".mkv",
      ".wmv",
      ".flv",
    ];

    return allDocs.filter((doc) =>
      allowedExtensions.some((ext) => doc.name?.toLowerCase().endsWith(ext))
    );
  }

  if (type === "webpage") {
    return allDocs.filter((doc) => doc.type === "webpage");
  }

  if (type === "youtube_audio") {
    return allDocs.filter((doc) => doc.type === "youtube_audio");
  }

  return [];
};
